import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-39514f9a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "industry" }
const _hoisted_2 = { class: "sections" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "industry__image" }
const _hoisted_5 = { class: "industry__header" }
const _hoisted_6 = { class: "subtitle subtitle--left text-primary" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "container" }
const _hoisted_10 = { class: "industry__header" }
const _hoisted_11 = { class: "subtitle subtitle--left text-primary" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = { class: "industry__image" }
const _hoisted_15 = { class: "industry__expertise container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_thumb = _resolveComponent("thumb")!
  const _component_images_slider = _resolveComponent("images-slider")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_thumb, {
            file: _ctx.page?.additionalThumb1
          }, null, 8, ["file"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.page?.bullets[0]?.icon), 1),
          _createElementVNode("h2", {
            class: "industry__title highlighted highlighted--primary",
            innerHTML: _ctx.titlePipe(_ctx.page?.bullets[0]?.title)
          }, null, 8, _hoisted_7),
          _createElementVNode("p", {
            class: "lead",
            innerHTML: _ctx.titlePipe(_ctx.page?.bullets[0]?.description)
          }, null, 8, _hoisted_8)
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.page?.bullets[1]?.icon), 1),
          _createElementVNode("h2", {
            class: "industry__title highlighted highlighted--primary",
            innerHTML: _ctx.titlePipe(_ctx.page?.bullets[1]?.title)
          }, null, 8, _hoisted_12),
          _createElementVNode("p", {
            class: "lead",
            innerHTML: _ctx.titlePipe(_ctx.page?.bullets[1]?.description)
          }, null, 8, _hoisted_13)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_thumb, {
            file: _ctx.page?.additionalThumb2
          }, null, 8, ["file"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("h3", null, _toDisplayString(_ctx.page?.title), 1),
      _createVNode(_component_images_slider, {
        class: "certificates",
        images: _ctx.certificates,
        options: _ctx.options,
        "show-title": true,
        id: 'certificates'
      }, null, 8, ["images", "options"])
    ])
  ]))
}